import { render, staticRenderFns } from "./PersonaProgramaPage.vue?vue&type=template&id=4d3a258d"
import script from "./PersonaProgramaPage.js?vue&type=script&lang=js&external"
export * from "./PersonaProgramaPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports